import { addWatcher, deleteWatcher, editWatcher, toggleWatcher, triggerNowWatcher } from "../../NotificationManager/actions.js";

import ItemListView from "../../../components/ItemListView/ItemListView.vue";
import ItemView from "../../../components/ItemView/ItemView.vue";

export default [
    {
        path: "/Admin/NotificationWatchers",
        component: { ...ItemListView },
        name: "Notification Watchers",
        meta: {
            app: "Admin",
            sideNav: true,
            sideNavSection: "Admin",
            sideNavPosition: 3,
            appSwitcher: false,
            icon: "bell",
            name: "Notification Watchers",
            tableSettings: "NotificationWatchers",
            dataPath: "NotificationManager/Watchers",
            selectionRoute: "Admin/NotificationWatchers/{ID}",
            lock(user) {
                return [user?.Security?.General?.ApplicationAdmin !== true, "Cannot view this area"];
            },
            hidden(user) {
                return user?.Security?.General?.ApplicationAdmin !== true;
            },
            menuActions: [
                { label: "Add Watcher", action: addWatcher },
            ],
        },
    },
    {
        path: "/Admin/NotificationWatchers/:id",
        component: ItemView,
        name: "Notification Watcher",
        meta: {
            app: "Admin",
            sideNav: false,
            appSwitcher: false,
            name: "Notification Watcher",
            dataPathOverride: "NotificationManager/Watchers/:id",
            lock(user) {
                return [user?.Security?.General?.ApplicationAdmin !== true, "Cannot view this area"];
            },
            title(item) {
                return `Watcher: ${item?.type || "Untitled"}`;
            },
            dataFields: [
                { label: "Status", break: true, class: "md:col-span-3" },
                { label: "Enabled", key: "enabled", type: "bool" },
                { label: "Type", key: "type" },
                {
                    label: "Trigger",
                    compute({ pageItem }) {
                        return pageItem?.trigger === "cron" ? "Cron (scheduled)" : "Event (on data change)";
                    },
                },
                { label: "Content", break: true, class: "md:col-span-3" },
                { label: "Title", key: "title" },
                { label: "Body", key: "body" },
                { label: "Paths", break: true, class: "md:col-span-3" },
                { label: "Source Path", key: "sourcePath" },
                { label: "Target Path", key: "targetPath" },
                { label: "Users", break: true, class: "md:col-span-3" },
                { label: "Recipient Mode", key: "recipientMode" },
                { label: "Dynamic Recipient Field", key: "dynamicRecipientField" },
                {
                    label: "User Count",
                    compute({ pageItem }) {
                        const ids = pageItem?.userIds;
                        return Array.isArray(ids) ? ids.length : 0;
                    },
                },
                {
                    label: "User IDs",
                    compute({ pageItem }) {
                        const ids = pageItem?.userIds;
                        return Array.isArray(ids) ? ids.join(", ") : "—";
                    },
                },
                { label: "Action", break: true, class: "md:col-span-3" },
                { label: "Action Route", key: "actionRoute" },
                { label: "Action Label", key: "actionLabel" },
                { label: "Delivery Mode", key: "deliveryMode" },
                { label: "Filter", break: true, class: "md:col-span-3" },
                { label: "Filter Field", key: "filters.field" },
                { label: "Filter Operator", key: "filters.operator" },
                { label: "Filter Value", key: "filters.value" },
                { label: "Schedule", break: true, class: "md:col-span-3" },
                { label: "Frequency", key: "schedule.frequency" },
                {
                    label: "Day",
                    compute({ pageItem }) {
                        const s = pageItem?.schedule;
                        if (!s) return "—";
                        if (s.frequency === "Weekly") {
                            const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                            return days[s.dayOfWeek] ?? "—";
                        }
                        if (s.frequency === "Monthly") return s.dayOfMonth ?? "—";
                        return "—";
                    },
                },
                {
                    label: "Conditions",
                    class: "md:col-span-3",
                    compute({ pageItem }) {
                        const conditions = pageItem?.conditions;
                        if (!Array.isArray(conditions) || conditions.length === 0) return "—";
                        return conditions
                            .map((c) => `${c.field} ${c.operator} ${c.value === true ? "" : c.value}`.trim())
                            .join("  |  ");
                    },
                },
                { label: "Last Run", key: "lastRunAt", type: "date" },
                { label: "Dates", break: true, class: "md:col-span-3" },
                { label: "Created", key: "createdAt", type: "date" },
                { label: "Updated", key: "updatedAt", type: "date" },
            ],
            menuActions: [
                { label: "Edit Watcher", action: editWatcher },
                { label: "Trigger Now", action: triggerNowWatcher },
                { label: "Toggle Enabled", action: toggleWatcher },
                { label: "Delete Watcher", action: deleteWatcher },
            ],
        },
    },
];
